import { defaultPayBounds } from "../../../../../../shared/util/salary/payBoundsByCountry";
import { SalaryType } from "../../../../../../shared/util/salary/SalaryType";

// US fallback used when OneGraph (SAL-7306) bounds are unavailable. Typed
// as Record<SalaryType, ...> so adding a SalaryType member without a
// matching fallback row is a compile error rather than a runtime undefined.
export const payBounds: Record<SalaryType, readonly [number, number]> = {
  [SalaryType.Hourly]: defaultPayBounds.HOURLY,
  [SalaryType.Daily]: defaultPayBounds.DAILY,
  [SalaryType.Weekly]: defaultPayBounds.WEEKLY,
  [SalaryType.Monthly]: defaultPayBounds.MONTHLY,
  [SalaryType.Yearly]: defaultPayBounds.YEARLY,
};

export type PayBoundsKey = SalaryType;
export type PayBoundsMap = Partial<Record<PayBoundsKey, readonly [number, number]>>;

export function getPayBounds(
  salaryType: PayBoundsKey,
  dynamicPayBounds?: PayBoundsMap,
): readonly [number, number] {
  return dynamicPayBounds?.[salaryType] ?? payBounds[salaryType];
}
